import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { FormBuilder } from '@angular/forms';
import { FilterService } from '@progress/kendo-angular-grid';
import { Logger } from '@app/core';

const log = new Logger('KendoUniversalBooleanSelectComponent');

@Component({
  selector: 'app-kendo-universal-boolean-select',
  templateUrl: './kendo-universal-boolean-select.component.html',
  styleUrls: ['./kendo-universal-boolean-select.component.scss'],
})
export class KendoUniversalBooleanSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field: string;

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      bool: [this.getObjectId(this.field)],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect() {
    const event = this.form.get('bool')?.value;

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
  }
}
